export default __webpack_public_path__ + "static/healthnet-0bffafc70024a9fcb9d551c160c86b2b.svg";